module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_aol-9331825a868fa156134a34d0a4c47585.png";